import React from 'react';

import { Subsite } from 'api/website';
import Box from 'components/Box';
import Breadcrumbs from 'components/Breadcrumbs';
import PrintHidden from 'components/PrintHidden';
import { Line as LoadingLine } from 'components/SearchLoadingSection';
import ClientOnly from 'containers/ClientOnly';
import PostSearchInputContainer from 'containers/PostSearchInputContainer';
import { Page } from 'store/main/ducks/contents';
import { colors, gutterWidth, shadows } from 'theme';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const SearchToolbar = ({
  content,
  subsite,
  searchMode,
}: {
  content: Page;
  subsite: Subsite;
  searchMode?: boolean;
}) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line prefer-destructuring
  const homePage = subsite.homePage;
  const isHomePage = homePage && homePage.url === content.url;
  const hasBreadcrumbs = !isHomePage || (isHomePage && searchMode);
  const links = [
    {
      title: subsite.publicName,
      to: `/${subsite && homePage.url}`,
      'data-qa-id': 'breadcrumbs-home-link',
    },
  ];

  if (!isHomePage) {
    links.push({
      title: content.title,
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ pathname: string; state: { subsite: Subsit... Remove this comment to see the full error message
      to: {
        pathname: `/${content.url}`,
        state: {
          subsite,
        },
      },
    });
  }

  return (
    <PrintHidden>
      <Box
        data-qa-id="search-toolbar"
        position="relative"
        zIndex={1}
        py={12}
        px={gutterWidth / 2}
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        bg={colors.white}
        borderTop={`1px solid ${colors.platinum}`}
        boxShadow={shadows.toolbar}
      >
        <Box width="50%" flex="0 0 auto" pr={16}>
          {hasBreadcrumbs && (
            <ClientOnly
              placeholder={
                <Box display="flex" alignItems="center">
                  <LoadingLine width={120} height={12} />
                  <LoadingLine
                    width="8px"
                    height="8px"
                    mx={20}
                    borderRadius="50%"
                  />
                  <LoadingLine width={160} height={12} />
                </Box>
              }
            >
              <Breadcrumbs links={links} />
            </ClientOnly>
          )}
        </Box>
        <Box
          width={586}
          maxWidth="50%"
          justifyContent="flex-end"
          display="flex"
        >
          <PostSearchInputContainer
            homePageUrl={subsite.homePage.url}
            searchPlaceholderText={subsite.searchPlaceholderText}
          />
        </Box>
      </Box>
    </PrintHidden>
  );
};

export default SearchToolbar;
